import { Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function FloatingCall() {
  const { content } = useSite();
  return (
    <a
      href={`tel:${content?.phone}`}
      data-testid="floating-call-btn"
      className="md:hidden fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-brand-red shadow-[0_12px_30px_-6px_rgba(230,57,70,0.7)] active:scale-95 transition-transform"
      aria-label={`Call ${content?.phone}`}
    >
      <Phone size={22} />
    </a>
  );
}
